module.exports = __webpack_public_path__ + "media/getraenke_holen.8578f592.mp4";